import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavEntryPoint } from '@retailer-platform/dashboard/routing'
import { recipesV2PartnerScopedRouter } from './routing/recipesV2PartnerScopedRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { recipesV2AccessControl } from './access-control/recipesV2Access.configuration'
import { Permission } from './access-control/permissions'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'recipes-v2',
  totem: {
    // The default IPP tool of all routes in this domain
    tool: 'recipes-v2-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  routers: {
    partnerScoped: [recipesV2PartnerScopedRouter],
  },
  navigationEntries: [
    {
      attachToV2: NavEntryPoint.Merchandising,
      subNavItems: [
        {
          type: 'item',
          llmDescription: 'Create, edit, and manage recipe content for display on storefront pages',
          labelId: 'recipesV2Domain.navigation.recipes',
          route: 'recipes-v2',
          accessControl: recipesV2AccessControl,
          positionNavV2: 10, // Position in nav - can be adjusted
          inToolPermissions: [
            {
              slug: Permission.Admin,
              permissionLabelId: 'permissionAccordion.permissions.' + Permission.Admin,
            },
            // TODO: Add when backend permissions are ready
            // {
            //   slug: Permission.RecipesV2Modify,
            //   permissionLabelId: 'permissionAccordion.permissions.' + Permission.RecipesV2Modify,
            // },
          ],
        },
      ],
    },
  ],
}

export default definition
